const isValidPhoneNumber = (phoneNumber: string): boolean => {
  // This regex checks for valid phone numbers in formats such as (123) 456-7890, 123-456-7890, +1234567890, etc.
  const re: RegExp =
    /^(?:\+?\d{1,3})?[-.\s]?(\(?\d{1,4}\)?)?[-.\s]?\d{1,4}[-.\s]?\d{1,9}(?:[-.\s]\d{1,9})?$/
  return re.test(phoneNumber)
}

export default isValidPhoneNumber
